import React, { useRef } from "react";
import { DataGrid } from "devextreme-react/data-grid";
import ChartCard from "components/common/pyramid/ChartCard";

const MarginalCumulativeEffects = ({ data }) => {
  const dataGridRef = useRef(null);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const formatCurrency = (cellInfo) => {
    const value = cellInfo.value;
    if (value === null) return " ";
    return formatter.format(value);
  };

  const columns = [
    {
      dataField: "Effects",
      caption: "Effects",
      alignment: "left",
    },
    {
      dataField: "Marginal",
      caption: "Marginal",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "Cumul",
      caption: "Cumul",
      alignment: "right",
      customizeText: formatCurrency,
    },
    {
      dataField: "EclValue",
      caption: "ECL Value",
      alignment: "right",
      customizeText: formatCurrency,
    },
  ];

  return (
    <ChartCard
      title="Marginal & Cumulative Effects"
      className="pt-0 pb-3 ps-3 pe-3"
      dataGridRef={dataGridRef}
    >
      <DataGrid
        ref={dataGridRef}
        dataSource={data}
        columns={columns}
        showBorders={true}
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        allowColumnReordering={false}
        allowColumnResizing={false}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        sorting={{ mode: "none" }}
        headerFilter={{ visible: false }}
      />
    </ChartCard>
  );
};

export default MarginalCumulativeEffects;
